import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { PageHeader } from '@/components/shared/PageHeader';
import { WithdrawalDialog } from '@/components/features/withdrawals/WithdrawalDialog';
import { WithdrawalHistoryTable } from '@/components/features/withdrawals/WithdrawalHistoryTable';
import { WithdrawalFilters } from '@/components/features/withdrawals/WithdrawalFilters';
import { useWithdrawalHistory} from '@/lib/hooks';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import type {WithdrawalFilters as WithdrawalFiltersType, WithdrawalTransaction} from '@/lib/types';
import {DataTablePagination} from "@/components/shared";

export const Route = createFileRoute('/_auth/withdrawals/')({
  component: WithdrawalsComponent,
});

function WithdrawalsComponent() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [filters, setFilters] = useState<WithdrawalFiltersType>({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const { data, isLoading } = useWithdrawalHistory({
    ...filters,
    page,
    per_page: perPage,
  });


  if(!isLoading) {
      return (
          <div className="space-y-6">
              <PageHeader
                  title="Выводы"
                  description=""
                  action={
                      <Button onClick={() => setDialogOpen(true)}>
                          <Plus className="mr-2 h-4 w-4" />
                          Вывести
                      </Button>
                  }
              />

              <WithdrawalFilters filters={filters} onFiltersChange={setFilters} />

              <WithdrawalHistoryTable
                  data={(data?.data || []) as WithdrawalTransaction[]}
                  isLoading={isLoading}
              />

              <DataTablePagination meta={data!.meta} onPageChange={setPage} onPerPageChange={setPerPage} />

              <WithdrawalDialog open={dialogOpen} onOpenChange={setDialogOpen} />
          </div>
      );
  }
}
